
import Menu from '../../components/customer/Menu'
import CompanyFooter from '../../components/customer/CompanyFooter'
import OrdersBoard from '../../components/customer/OrdersBoard'

export default function OrdersBoardPage() {
    return (
        <div className='streach'>
            <Menu />

            <OrdersBoard className='mx-4' />
            <CompanyFooter />
        </div>
    )
}
